import { render } from "./message.vue?vue&type=template&id=2f4fff2e&scoped=true"
import script from "./message.vue?vue&type=script&lang=js"
export * from "./message.vue?vue&type=script&lang=js"

import "./message.vue?vue&type=style&index=0&id=2f4fff2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f4fff2e"]])

export default __exports__